/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Tree_Collapse_LabelInputs */



/**
* | output |
* | --- |
* | "Collapse" |
*
* @param {Explorer_Tree_Collapse_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_tree_collapse_label = /** @type {((inputs?: Explorer_Tree_Collapse_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Tree_Collapse_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reduire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenbruch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crollo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Крах")
	if (locale === "es") return /** @type {LocalizedString} */ ("Colapsar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("坍塌")
	if (locale === "ja") return /** @type {LocalizedString} */ ("崩壊")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गिर जाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Colapso")
	return /** @type {LocalizedString} */ ("Collapse")
});